import React from 'react'
import { CardActionArea } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';


const ItemsForm = ({ CartCount,SelectedType,Items, ShowDetails, LanguageID, RestInformation ,ThemeColor}) => {


  return (

    <div style={{
      height: (CartCount > 0 || SelectedType === 'Details' || SelectedType === 'Done') ? '68vh' : '78vh',            // Set height to allow space
      overflowY: 'auto',        // Enable vertical scroll
      padding: '10px',
    }}>
      <div className='row' style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',

      }}>
        {Items.map((item) => (
          <div>
            <Card sx={{
              minWidth: 350, maxWidth: 350, margin: '8px',borderRadius:'15px',

              backgroundColor: (item.availble == 0 || RestInformation.availble == 0) ? 'lightgrey' : 'white',
              opacity: (item.availble == 0 || RestInformation.availble == 0) ? 0.5 : 1,
              pointerEvents: (item.availble == 0 || RestInformation.availble == 0) ? 'none' : 'auto'


            }} onClick={() => ShowDetails('Details', item.itemID, item)}>

              <CardActionArea>
                {(LanguageID == 1 || LanguageID == 3) && (
                  <div className='row' style={{ display: 'flex' }}>

                    <div className='col'   >

                      <img src={item.imageUrl} alt="Logo" style={{ borderRadius: '10px', maxHeight: 100, minHeight: 100, maxWidth: 100, minWidth: 100, margin: '8px' }} />
                      <label
                        style={{
                          fontFamily: 'basheer',
                        
                          position: 'absolute',
                          bottom: '5px',
                          right: '5px',
                         
                          

                        }}
                      >
                       <div className='row' style={{ fontSize: '20px',     fontFamily: 'basheer',  color: `#${ThemeColor}`, display: 'flex', direction: 'rtl',   }}>
                        <div className='col'>
                          <label >{item.itemPrice.toLocaleString()} </label>
                          <label style={{ marginRight: '5px' }}> د.ع</label>
                        </div>

                      </div>


                      </label>




                    </div>


                    <div className='col' style={{ minWidth: '60%' }}>
                      <div className='row' style={{ fontSize: '16px', fontFamily: 'basheer', textAlign: 'start',  marginRight: '5px', marginTop: '5PX', direction: 'rtl' }}>
                        {(LanguageID == 1) && (

                          <label>{item.itemName}</label>

                        )}

                        
                      </div>

                      <div className='row' style={{ fontSize: '12px', textAlign: 'start', marginRight: '2px', direction: 'rtl' }}>




                        {(item.itemMem != '' && item.itemMem != null) && (
                          <div className='row' style={{ fontSize: '14px', textAlign: 'start', marginRight: '5px',  fontWeight: 'bold' }}>


                            <label style={{ fontSize: '13px', fontFamily: 'basheer', color: '#A4B0B6' }}>( {item.itemMem} )</label>


                          </div>
                        )}

                       

                       
                      </div>





                    </div>



                  </div>
                )}
               

              </CardActionArea>

            </Card>

            <div>











            </div>


          </div>

        ))}

      </div>
    </div>
  )
}


export default ItemsForm